'use strict';

angular.module('shiftTraderApp')
  .controller('ActivateUserCtrl', function ($scope, $stateParams, $http, $location, $timeout, $window, ServerUrls, flash, SAErrorHandler, HardNavigationService) {
    $scope.activationCode = $stateParams.activationCode;
    $scope.activationFail = false;
    $scope.activationSent = false;
    $scope.activationSuccess = false;
    $scope.form = {
      password: '',
      password_confirmation:''
    };

    $scope.activateAccount = function() {
      if ($scope.activateUserForm.inputPassword.$invalid) {
        flash.error = 'Password must be more than 8 characters long.';
      } else if ($scope.activateUserForm.inputPasswordConfirmation.$invalid || $scope.form.password !== $scope.form.passwordConf) {
        flash.error = 'Password and password confirmation must match.';
      } else {
        var data = {
          user: {
            activation_code: $scope.activationCode,
            password: $scope.form.password,
            password_confirmation: $scope.form.passwordConf
          }
        };
        return $http.put(ServerUrls.current.railsApi + 'registrations/', data)
          .then(function(response) {
            $scope.activationSent = true;
            if (response.status === 204) {
              console.log('status is good! password reset successfully');
              $scope.activationSuccess = true;
              flash.success = 'Activation successful! Will redirect to login...';

              $timeout(function() {
                HardNavigationService.navigateTo('login', true);
              }, 1500);

            } else {
              $scope.activationFail = true;
              flash.error = 'Activation failure.  Please try again.';
            }
            $scope.password = '';
            $scope.password_confirmation = '';
            return response;
          }, function(response) {
            SAErrorHandler.processError(response);
          });
      }
    };
  });
